module.exports = __webpack_public_path__ + "static/media/Attachment 1 - Project Document Guidelines.4ae4fe7b.pdf";